import {
  ROLE_CLINIC_ADMINISTRATOR,
  ROLE_FINANCIAL,
  ROLE_FINANCIAL_ADMINISTRATOR,
  ROLE_OTHER_HEALTH_PROFESSIONAL,
  ROLE_PARTNERSHIP,
  ROLE_PROFESSIONAL,
  ROLE_RECEPTIONIST,
  ROLE_STUDENT
} from 'constants/types';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import useAuth from './useAuth';

const usePermissions = () => {
  const data = useSelector((state) => state.auth);
  const { isAdmin, tenantId } = useAuth();

  const hasRole = useCallback(
    (...roles) => data.user.roles.some((role) => roles.includes(role)),
    [data]
  );

  const isProfessional = hasRole(
    ROLE_PROFESSIONAL,
    ROLE_OTHER_HEALTH_PROFESSIONAL
  );
  const isStudent = hasRole(ROLE_STUDENT);
  const isReceptionist = hasRole(ROLE_RECEPTIONIST);
  const isClinicAdmin = hasRole(ROLE_CLINIC_ADMINISTRATOR);
  const isUserAdmin = hasRole(
    ROLE_CLINIC_ADMINISTRATOR,
    ROLE_FINANCIAL_ADMINISTRATOR
  );
  const isFinancial = hasRole(ROLE_FINANCIAL);
  const isPartnership = hasRole(ROLE_PARTNERSHIP);
  const isFinancialAdministrator = hasRole(ROLE_FINANCIAL_ADMINISTRATOR);

  return {
    isProfessional,
    isStudent,
    isClinicAdmin,
    isUserAdmin,
    isReceptionist,
    isAdmin: isAdmin(),
    isFinancial,
    isPartnership,
    isFinancialAdministrator,
    hasTenantId: !!tenantId
  };
};

export default usePermissions;
